<template>
    <div>{{ displayId() }}</div>
</template>

<script setup lang="ts">
import type { ParticipantID, RaceContestantDetails } from '@/objects/generated';
import WellKnown from '@/objects/generated/static/WellKnown';

const props = defineProps<{
    /**
     * The emit ID to display
     */
    value: ParticipantID[] | null;

    row: RaceContestantDetails | null;

    /**
     * The type of ID to display
     */
    idtype: 'EMIT' | 'BUYPASS' | 'NIF' | 'FIS';
}>();

const displayId = () => {
    if (!props.value || !props.row) return '';

    if (props.idtype === 'EMIT') {
        return props.value?.find((id) => id.ParticipantIDTypeID === WellKnown.IDTYPE_EMIT)?.Value ?? '';
    } else if (props.idtype === 'BUYPASS') {
        return props.value?.find((id) => id.ParticipantIDTypeID === WellKnown.IDTYPE_BUYPASS_ID)?.Value ?? '';
    } else if (props.idtype === 'NIF') {
        return props.value?.find((id) => id.ParticipantIDTypeID === WellKnown.IDTYPE_NIF)?.Value ?? '';
    } else if (props.idtype === 'FIS') {
        return props.value?.find((id) => id.ParticipantIDTypeID === WellKnown.IDTYPE_FIS_CODE)?.Value ?? '';
    }

    return '';
};
</script>
